export { default } from "@casino/external/icons/GenericInfo";
